import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MainFacade } from '../main.facade';
import { CountdownConfig } from 'ngx-countdown';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastService } from 'angular-toastify';
import { takeUntil} from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;
var moment = require('moment-timezone');
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public nfts$: Observable<any>|undefined;
  public season$: Observable<any>|undefined;
  public showNfts$: Observable<any>|undefined;
  private destroy$ = new Subject();
  public user$: Observable<any>|undefined;
  public filter$: Observable<any>|undefined;
  user:any='';


  constructor(private mainfacade:MainFacade, private sanitizer: DomSanitizer, private toastService: ToastService, private router:Router) { 

    
  }

 

 
  ngOnInit(): void {
    
    this.createSubscriptions();
  }




  ngOnDestroy() {
    this.destroy$.next(true);
  }

  
  createSubscriptions(){
    this.nfts$ = this.mainfacade.nfts$;
    this.showNfts$ = this.mainfacade.showNfts$
    this.user$ = this.mainfacade.user$;
    this.filter$ = this.mainfacade.filter$;
    this.season$ = this.mainfacade.season$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.user = message;
        }
    });

   

  }

  setFilter(value){
    this.mainfacade.setFilter(value);
  }




 
}
